/* eslint-disable no-param-reassign */
import { Transforms, Editor as SlateEditor } from 'slate';
import isEqual from 'lodash.isequal';
import { wrapNodes, insertNodes, isCollapsed, unwrapNodes, isEditor, isElement, ELEMENT_LINK, getPluginType, someNode, getEditorString, insertText as insertEditorText, } from '@udecode/plate';
import { EMPTY_VALUE } from './constants';
export function getSelectedText(editor) {
    if (editor.selection) {
        return getEditorString(editor, editor.selection);
    }
    return '';
}
export function isEmptyValue(value) {
    return (value === null || value === void 0 ? void 0 : value.length) === 1 && isEqual(EMPTY_VALUE, value[0]);
}
export function insertText(editor, text) {
    insertEditorText(editor, text);
}
export function isLinkActive(editor) {
    const type = getPluginType(editor, ELEMENT_LINK);
    const isLink = !!(editor === null || editor === void 0 ? void 0 : editor.selection) && someNode(editor, { match: { type } });
    return isLink;
}
export function removeLink(editor) {
    unwrapNodes(editor, {
        match: (n) => !isEditor(n) && isElement(n) && n.type === ELEMENT_LINK,
    });
}
export function insertLink(editor, url, text) {
    if (!editor.selection) {
        return;
    }
    if (isLinkActive(editor)) {
        removeLink(editor);
    }
    const type = getPluginType(editor, ELEMENT_LINK);
    if (isCollapsed(editor.selection)) {
        insertNodes(editor, {
            type,
            link: url,
            children: [{ text: text || url }],
        });
        return;
    }
    unwrapNodes(editor, { at: editor.selection, match: { type } });
    wrapNodes(editor, {
        type: type,
        link: url,
        children: [],
    }, { at: editor.selection, split: true });
}
export function resetSelection(editor) {
    const point = { path: [0, 0], offset: 0 };
    Transforms.select(editor, { anchor: point, focus: point });
}
export function calculateRowStyles(rows, maxRows) {
    if (!rows && !maxRows) {
        return {};
    }
    const adjustedRows = rows && maxRows && rows > maxRows ? maxRows : rows;
    return {
        overflow: 'auto',
        minHeight: adjustedRows ? `${adjustedRows * 1.3}em` : undefined,
        maxHeight: maxRows ? `${maxRows * 1.3}em` : undefined,
    };
}
export function clear(editor) {
    Transforms.delete(editor, {
        at: {
            anchor: SlateEditor.start(editor, []),
            focus: SlateEditor.end(editor, []),
        },
    });
}
//# sourceMappingURL=utils.js.map